import {
	Card,
	CardContent,
	InputAdornment,
	LinearProgress,
	Paper,
	Table,
	TableBody,
	TableCell,
	TablePagination,
	TableRow,
	TextField,
	Typography,
	IconButton,
	Icon
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Search } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem.jsx';
import {
	GetUserId,
	GetUserKey,
	GetUserToken,
	Logout
} from 'helpers/UserHelper';
import { getClientsByBroker } from 'queries/clientsByBroker';
import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import EnhancedTableHead from 'components/EnhancedTableHead/EnhancedTableHead.jsx';
import { SearchDataSet } from 'helpers/Search';
import { QuoteEligibility } from 'queries/QuoteEligibility';
import { Mutation } from 'react-apollo';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { DateTimeFormatter } from 'helpers/DateHelpers';

const columnData = [
	{
		id: 'edit',
		numeric: false,
		disablePadding: true,
		label: '',
		noSort: true,
		width: '30px'
	},
	{ id: 'scd_name', numeric: false, disablePadding: true, label: 'Name' },
	{ id: 'scd_email', numeric: false, disablePadding: true, label: 'Email' },
	{
		id: 'date_modified',
		numeric: false,
		disablePadding: true,
		label: 'Date Created / Modified'
	}
];

class ClientForQuote extends Component {
	state = {
		page: 0,
		rowsPerPage: 10,
		order: 'desc',
		orderBy: 'date_modified',
		searchTerm: '',
		loadingSearch: false,
		searchData: [],
		assistantActive: false,
		eligibilityDialogOpen: false,
		invalidFields: [],
		selectedClient: {}
	};

	componentDidMount() {
		this.props.scrollMeBar();
	}

	handleSearch = event => {
		this.setState({ searchTerm: event.target.value });

		let values = event.target.value.split(' ');
		var data = this.props.data.getClientsByBroker;
		var inc = ['scd_name', 'scd_surname', 'scd_email', 'date_created'];

		var filteredData = SearchDataSet(data, values, inc);
		this.setState({ searchData: filteredData });
	};

	handleChangePage = (event, page) => {
		this.setState({ page });
	};

	handleChangeRowsPerPage = event => {
		this.setState({ rowsPerPage: event.target.value });
	};

	handleRequestSort = (event, property) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}

		this.setState({ order, orderBy });
	};

	getSorting(order, orderBy) {
		return order === 'desc'
			? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
			: (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
	}

	handleEdit(id) {
		this.props.history.push({
			pathname: '/app/quote/',
			search: `clientId=${atob(id).split(':')[1]}`
		});
	}

	handleEditClient() {
		this.props.history.push({
			pathname: '/app/EditClient',
			search: `clientId=${atob(this.state.selectedClient.id).split(':')[1]}`
		});
	}

	checkAssistantActive() {
		if (GetUserKey('userType') === '6') {
			if (!this.state.assistantActive) {
				this.setState({ assistantActive: true });
			}
			return true;
		}
		return false;
	}

	getBrokerId = () => {
		let brokerId = GetUserId();
		if (this.checkAssistantActive()) {
			brokerId = sessionStorage.getItem('ActiveBrokerId');
		}
		return brokerId;
	};

	getBrokerName = () => {
		return sessionStorage.getItem('ActiveBrokerName');
	};

	sortDateDesc = function(a, b) {
		return new Date(b.date_modified) - new Date(a.date_modified);
	};

	sortDateAsc = function(a, b) {
		return new Date(a.date_modified) - new Date(b.date_modified);
	};

	render() {
		this.checkAssistantActive();

		if (this.props.data.loading) {
			return <LinearProgress />;
		}

		if (
			this.props.data.error &&
			this.props.data.error.message &&
			this.props.data.error.message === 'GraphQL error: invalid token'
		) {
			Logout();
			return <Redirect to="/app/portal/login" />;
		}

		let data = [];
		if (this.state.searchData.length > 0 && this.state.searchTerm !== '') {
			data = this.state.searchData.slice();
		} else {
			data = this.props.data.getClientsByBroker.slice();
		}

		if (this.state.orderBy === 'date_modified') {
			data.sort(
				this.state.order === 'desc' ? this.sortDateDesc : this.sortDateAsc
			);
		} else {
			data.sort(this.getSorting(this.state.order, this.state.orderBy));
		}

		return (
			<Grid container>
				<GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
					<Card>
						<CardContent>
							<Grid
								container
								justify="space-between"
								style={{ marginBottom: '15px' }}
							>
								<Grid item xs={12} sm={12} md={12}>
									<Typography variant="headline">
										Choose Client for Quote
									</Typography>
									{this.state.assistantActive ? (
										<Typography variant="caption" gutterBottom>
											{this.getBrokerName()}
										</Typography>
									) : null}
								</Grid>
							</Grid>
							<TextField
								id="input-with-icon-textfield"
								fullWidth
								style={{ marginBottom: '3vh' }}
								placeholder="Search Client by Name, Surname,Email or Date Created(YYYY/MM/DD)"
								onChange={this.handleSearch}
								label="Search"
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Search />
										</InputAdornment>
									)
								}}
							/>

							<Paper style={{ overflowX: 'auto' }}>
								<Table>
									<EnhancedTableHead
										order={this.state.order}
										orderBy={this.state.orderBy}
										onRequestSort={this.handleRequestSort}
										rowCount={
											this.state.searchData.length < 1 &&
											this.state.searchTerm !== ''
												? this.state.searchData.length
												: data.length
										}
										columnData={columnData}
									/>
									<TableBody>
										{this.state.searchData.length < 1 &&
										this.state.searchTerm !== '' ? (
											<TableRow>
												<TableCell>
													<h3>No results found</h3>
												</TableCell>
											</TableRow>
										) : (
											data
												.slice(
													this.state.page * this.state.rowsPerPage,
													this.state.page * this.state.rowsPerPage +
														this.state.rowsPerPage
												)
												.map(client => {
													return (
														<Mutation
															key={client.id}
															mutation={QuoteEligibility}
															onCompleted={data => {
																var quoteEligibility = data.QuoteEligibility;
																if (!quoteEligibility.valid) {
																	let invalidFields = quoteEligibility.invalidFields.split(
																		','
																	);
																	this.setState({
																		eligibilityDialogOpen: true,
																		invalidFields: invalidFields,
																		selectedClient: client
																	});
																} else {
																	this.handleEdit(client.id);
																}
															}}
														>
															{mutate => (
																<TableRow
																	key={client.id}
																	className="sqDataTable"
																	onClick={() =>
																		mutate({
																			variables: {
																				input: {
																					clientId: atob(client.id).split(
																						':'
																					)[1]
																				}
																			}
																		})
																	}
																>
																	<TableCell
																		style={{
																			padding: '0px',
																			borderRight: '1px solid #e0e0e0',
																			backgroundColor: 'white'
																		}}
																	>
																		<IconButton
																			onClick={() =>
																				mutate({
																					variables: {
																						input: {
																							clientId: atob(client.id).split(
																								':'
																							)[1]
																						}
																					}
																				})
																			}
																		>
																			<Icon>more_vert</Icon>
																		</IconButton>
																	</TableCell>
																	<TableCell>
																		{client.scd_name} {client.scd_surname}
																	</TableCell>
																	<TableCell>{client.scd_email}</TableCell>
																	<TableCell>
																		{DateTimeFormatter(client.date_modified)}
																	</TableCell>
																</TableRow>
															)}
														</Mutation>
													);
												})
										)}
										<TableRow>
											<TablePagination
												count={
													this.state.searchData.length < 1 &&
													this.state.searchTerm !== ''
														? this.state.searchData.length
														: data.length
												}
												rowsPerPage={this.state.rowsPerPage}
												page={this.state.page}
												backIconButtonProps={{
													'aria-label': 'Previous Page'
												}}
												nextIconButtonProps={{
													'aria-label': 'Next Page'
												}}
												onChangePage={this.handleChangePage}
												onChangeRowsPerPage={this.handleChangeRowsPerPage}
											/>
										</TableRow>
									</TableBody>
								</Table>
							</Paper>
						</CardContent>
					</Card>
				</GridItem>

				{this.state.eligibilityDialogOpen ? (
					<SweetAlert
						warning
						style={{ wordWrap: 'break-word', top: '40%' }}
						title={'Ineligible'}
						confirmBtnCssClass={
							this.props.classes.button + ' ' + this.props.classes.success
						}
						cancelBtnCssClass={
							this.props.classes.button + ' ' + this.props.classes.danger
						}
						confirmBtnText="Edit Client"
						cancelBtnText="Close"
						onConfirm={() => {
							this.handleEditClient();
						}}
						onCancel={() => {
							this.setState({
								eligibilityDialogOpen: false
							});
						}}
						showCancel={!this.state.loadingDelete}
						showConfirm={!this.state.loadingDelete}
					>
						<Typography>
							{this.state.selectedClient.scd_name +
								' ' +
								this.state.selectedClient.scd_surname +
								' '}
							is ineligible for a quote.
						</Typography>
						<br />
						<Typography>Please update the following fields: </Typography>
						<Grid container className="invalidListBlock">
							{this.state.invalidFields.map((i, index) => {
								return (
									<Grid item xs={12} sm={6} md={6} key={index}>
										<Typography>{i}</Typography>
									</Grid>
								);
							})}
						</Grid>
					</SweetAlert>
				) : null}
			</Grid>
		);
	}
}

ClientForQuote = graphql(getClientsByBroker, {
	options: () => ({ fetchPolicy: 'cache-and-network' }),
	props: props => {
		if (props.data.error) {
		}

		return { ...props };
	}
})(ClientForQuote);

ClientForQuote = connect(state => ({
	brokerId:
		GetUserKey('userType') === '6'
			? sessionStorage.getItem('ActiveBrokerId')
			: GetUserId(),
	token: GetUserToken(),
	status: 'own',
	userType: GetUserKey('userType')
}))(ClientForQuote);

export default withStyles(sweetAlertStyle)(ClientForQuote);



// WEBPACK FOOTER //
// ./src/views/Clients/components/ClientForQuote.jsx